<template>
  <div v-if="loaded" class="print-main">
    <div class="print-left" :style="{ height: `${this.$util.getViewHeight() - 162}px` }">
      <div id="print-content" class="print-content">
        <!-- title -->
        <div class="title-box">
          <h1 class="title-main">{{ $constant.company_info.company_name }}</h1>
          <h2 class="title-sub">{{ titleStr }}</h2>
        </div>

        <!-- formData1 -->
        <div class="form-main">
          <div class="form-list" v-for="(itemSt, indexSt) in formData1" :key="indexSt">
            <div class="form-item" v-for="(itemNd, indexNd) in itemSt" :key="indexNd">
              <div class="form-key">{{ itemNd.key }}{{ itemNd.key && '：' }}</div>
              <div class="form-val" v-if="itemNd.val">
                <span v-if="itemNd.val === 'shen_gou_bill_date'">
                  {{
                    detailData.formData[itemNd.val]
                      ? detailData.formData[itemNd.val].slice(0, 10)
                      : '&nbsp;'
                  }}
                </span>
                <span v-else>
                  {{ detailData.formData[itemNd.val] || '&nbsp;' }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- tableData -->
        <div class="table-main">
          <PrintTable :data="detailData.list" />
        </div>

        <!-- yao qiu -->
        <div class="table-main">
          <PrintYaoqiuTable :data="detailData.qi_ta_yao_qiu_list" />
        </div>

        <!-- 确认 -->
        <div class="flex">
          <div class="flex-1 f-bold">采购方确认及电话：</div>
          <div class="flex-1 f-bold">供应方确认：</div>
        </div>
      </div>
    </div>
    <div class="print-right">
      <div class="print-do">
        <div>
          <el-button class="print-btn" v-print="printData" type="primary" size="small">
            打印
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrintTable: () => import('./print-table'),
    PrintYaoqiuTable: () => import('./print-yaoqiu-table')
  },
  data() {
    return {
      loaded: false,
      detailData: {},
      printData: {
        id: 'print-content',
        popTitle: '&nbsp;'
      },
      formData1: [
        [
          {
            key: '销售单号',
            val: 'bill_code'
          },
          {
            key: '采购申请单号',
            val: 'shen_gou_code'
          }
        ],
        [
          {
            key: '业务员',
            val: 'saler_name'
          },
          {
            key: '采购申请日期',
            val: 'shen_gou_bill_date'
          }
        ]
      ]
    }
  },
  computed: {
    applyCode() {
      return this.$route.query.code
    },
    titleStr() {
      let result = '采购申请单'
      let isYuanliao = this.detailData.list.every((item) => item.type_name == '原料')
      let isJiagong = this.detailData.list.every((item) => item.type_name == '加工')
      if (isYuanliao) result = '材料申购单'
      if (isJiagong) result = '加工申购单'
      return result
    }
  },
  mounted() {
    this.getDetailData()
  },
  methods: {
    // 获取详情数据
    getDetailData() {
      this.loaded = false
      this.$api({
        method: 'get',
        url: '/admin/gcvip/shengou/detailShenGouCode',
        params: {
          code: this.applyCode
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = {}
            let list = []
            data.formData = this.$util.deepCopy(res.data.formData)
            data.qi_ta_yao_qiu_list = this.$util.deepCopy(res.data.qi_ta_yao_qiu_list)
            res.data.data.forEach((itemSt) => {
              itemSt.forEach((itemNd) => {
                list.push(itemNd)
              })
            })
            data.list = this.$util.deepCopy(list)
            this.detailData = this.$util.deepCopy(data)
          }
        })
        .catch(() => {})
        .then(() => {
          this.loaded = true
        })
    }
  }
}
</script>

<style lang="less" scoped>
// print
.print-main {
  display: flex;
  background: #f5f7fa;
  .print-left {
    margin: 10px;
    padding: 20px;
    width: 712px;
    background: #fff;
    overflow-y: auto;
    .scroll-bar();
  }
  .print-right {
    margin: 10px 10px 10px 0;
    padding: 10px;
    width: 200px;
    background: #fff;
    .print-btn {
      width: 100%;
    }
    .print-do {
      margin-bottom: 20px;
      padding: 20px;
      text-align: center;
      font-size: 14px;
      background: #f8f8f8;
    }
  }
}

// content
.print-content {
  font-size: 12px;
  line-height: 1.5;
  font-family: 'Arial,Microsoft YaHei,SimHei,SimSun';
  overflow: hidden;
}

// title
.title-box {
  margin: 10px 0 30px 0;
  text-align: center;
}
.title-main {
  margin: 0;
  font-size: 24px;
}
.title-sub {
  position: relative;
  margin: 20px 0 0 0;
  font-size: 20px;
}

// form
.form-main {
  position: relative;
  display: flex;
  margin-top: 20px;
}
.form-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  & ~ .form-list {
    margin-left: 10px;
  }
  .form-item {
    flex: 1;
    display: flex;
    align-items: center;
    .form-key {
      border-bottom: 1px solid #fff;
    }
    .form-val {
      flex: 1;
      padding: 2px 0;
      border-bottom: 1px solid #000;
    }
  }
}

// table
.table-main {
  margin: 20px 0;
}
</style>
